import { useQuery } from '@tanstack/react-query';

import type { ApiError } from '../@types';
import type { AffiliateCampaignDetails } from '../@types/api';
import { QUERY_KEYS } from '../constants';
import API_ROUTES from '../constants/apiRoutes';
import { getData } from '../utils/api';

export const useCampaignDetailsQuery = (campaignId?: string | null) =>
  useQuery<AffiliateCampaignDetails | null, ApiError>({
    queryKey: [QUERY_KEYS.campaigns, campaignId],
    queryFn: () => getData(`${API_ROUTES.CAMPAIGNS}/${campaignId}`, {}, 'crm'),
    enabled: !!campaignId,
    refetchOnMount: 'always',
  });
